"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _text_input = require("../../text_input");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 *
 * @todo consider adding required prop and error messaging logic?
 */
var CompanyNameInput = function CompanyNameInput(_ref) {
  var register = _ref.register,
    name = _ref.name;
  return /*#__PURE__*/_react["default"].createElement(_text_input.TextInput, {
    type: "text",
    label: "Company",
    name: name,
    register: register,
    cypressClass: "company-name"
  });
};
CompanyNameInput.propTypes = {
  /**
   * Object containing the errors from this input field.
   */
  errors: _propTypes["default"].object,
  /**
   * A boolean that determines if the name field is required or not.
   */
  required: _propTypes["default"].bool,
  /**
   * A function that gets passed for the useForm hook from react-hook-form to register an input
   *
   */
  register: _propTypes["default"].func.isRequired
};
CompanyNameInput.defaultProps = {
  errors: {},
  register: function register() {},
  name: 'companyName'
};
var _default = exports["default"] = CompanyNameInput;